import { render } from "./AdminListing.vue?vue&type=template&id=0fa91a54"
import script from "./AdminListing.vue?vue&type=script&lang=js"
export * from "./AdminListing.vue?vue&type=script&lang=js"
script.render = render

export default script